module.exports = __webpack_public_path__ + "static/img/dsk-projects-bg.cd51a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-projects-bg.jpg
// module id = 233
// module chunks = 1